import TagManager from 'react-gtm-module'

export const tagManagerArgs = {
    gtmId: 'G-EFEQZ249BV',
    dataLayerName: 'PageDataLayer'
}
TagManager.initialize(tagManagerArgs)

export default TagManager